import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useQueries from '../../../database/useQueries';
import { useSelector } from 'react-redux';
import FormTemplate from '../../template/form/FormTemplate';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import CommponentOptions from './data/commponentOptions';
import { v4 as uuidv4 } from 'uuid';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { GlobalContext } from '../../../App';
import { addRecordToCache, createFetchDataServer, getTableData } from '../../../database/fetchData';

const NAME_ENTITY = 'חלקה';

function PlotCreate() {
  // קבלת ערכים מהסטור
  const columns = useSelector((state) => state.columnsFormPlots.data);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  const [loading, setLoading] = useState(true); // מצב טעינה
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט
  const [loadingData, setLoadingData] = useState(false);

  // טעינת היוזים לפונקציות עזר
  const { addOrUpdateDataPlot, getEntitiesByAttr, getEntityByAttr } = useQueries();

  // ערכי הראוטר
  const location = useLocation();
  const navigate = useNavigate();
  const { value } = location.state || {};

  const { setTotalWidthContainer } = useContext(TemplateContext);
  const { token, setTitle } = useContext(GlobalContext);

  useEffect(() => {
    setTotalWidthContainer(1200);
    setTitle(`הוספת חלקה`);
  }, [location.pathname]);

  // משתנים לערכי סלקט של השדות
  const [cemeteries, setCemeteries] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [plots, setPlots] = useState([]);

  // איזור המשתנים והסטייטים
  // משתנים לטופס
  const [fieldsWithDynamicDisabled, setFieldsWithDynamicDisabled] = useState([]); // השדות
  const [formValues, setFormValues] = useState({}); // ערכי השדות
  const [errors, setErrors] = useState({}); // שגיאת השדות

  // פונקציה לטעינת השדות מתוך הסטור
  const myColumns = () => {
    return columns.map((field) => {
      return {
        ...field,
        disabled: field.disabled && value !== undefined,
        required: field.required || false,
        show: field?.show || false
      };
    });
  };

  // טעינת הנתונים לאחר קבלת הערכים מהדאטה בייס הלוקלי
  const handleAllDataLoaded = () => {
    setFieldsWithDynamicDisabled(myColumns());
    if (value?.unicId) {
      let initialFormValues = myColumns()
        .filter((field) => field?.name)
        .reduce((acc, field) => {
          // let fieldValue = data[field.name] || '';
          return {
            ...acc
            // [field.name]: fieldValue,
          };
        }, {});
      let res = fieldAuto(value, initialFormValues);
      initialFormValues = res;

      if (Object.keys(formValues).length === 0) {
        setFormValues(initialFormValues); // newValues הם הערכים החדשים שברצונך לעדכן
      }
    }
  };

  // טעינת ערכים אוטומטית לשדות
  const fieldAuto = (data, newFormValues) => {
    const block = getEntityByAttr(context?.contextBlocks, 'unicId', data?.unicId);
    const cemetery = getEntityByAttr(context?.contextCemeteries, 'unicId', block?.cemeteryId);
    const cemeteryId = cemetery?.unicId;
    const blockId = block?.unicId;

    let blocks = getEntitiesByAttr(context?.contextBlocks, 'cemeteryId', cemeteryId);
    let plots = getEntitiesByAttr(context?.contextPlots, 'blockId', blockId);

    newFormValues = { ...newFormValues, cemeteryId, blockId };

    setCemeteries(context?.contextCemeteries?.map((cemetery) => CommponentOptions({ value: cemetery?.unicId, label: cemetery?.cemeteryNameHe })));
    setBlocks(
      blocks.map((block) => {
        return CommponentOptions({
          value: block?.unicId,
          label: block?.blockNameHe,
          dataUnderRigth: {
            title: 'בית עלמין: ',
            value: cemetery?.cemeteryNameHe
          }
        });
      })
    );
    setPlots(plots);

    return newFormValues;
  };

  // פעולות המתבצעות רק לאחר קבלת דאטה בייס ווליו מהראוטר
  useEffect(() => {
    !loading && handleAllDataLoaded();
  }, [loading, context?.contextCemeteries, context?.contextBlocks, context?.contextPlots]);

  // ---------------------

  const fieldChangeCemeteryId = (event, newFormValues) => {
    delete newFormValues?.blockId;

    if (event.target.value === '') {
      setBlocks(
        context?.contextBlocks.map((block) => {
          const cemetery = context?.contextCemeteries.find((cemetery) => cemetery?.unicId === block?.cemeteryId);
          return CommponentOptions({
            value: block?.unicId,
            label: block?.blockNameHe,
            dataUnderRigth: {
              title: 'בית עלמין: ',
              value: cemetery?.cemeteryNameHe
            }
          });
        })
      );
    } else {
      const blocks = getEntitiesByAttr(context?.contextBlocks, 'cemeteryId', event.target.value);
      const plots = context?.contextPlots.filter((plot) => blocks.some((block) => block?.unicId === plot.blockId));
      setBlocks(
        blocks.map((block) => {
          const cemetery = context?.contextCemeteries.find((cemetery) => cemetery?.unicId === block?.cemeteryId);
          return CommponentOptions({
            value: block?.unicId,
            label: block?.blockNameHe,
            dataUnderRigth: {
              title: 'בית עלמין: ',
              value: cemetery?.cemeteryNameHe
            }
          });
        })
      );
      setPlots(plots);
    }
  };
  const fieldChangeBlockId = (event, newFormValues) => {
    const plots = getEntitiesByAttr(context?.contextPlots, 'blockId', event.target.value);
    const block = getEntityByAttr(context?.contextBlocks, 'unicId', event.target.value);
    const cemetery = getEntityByAttr(context?.contextCemeteries, 'unicId', block?.cemeteryId);

    setPlots(plots);
    return { cemeteryId: cemetery?.unicId };
  };
  const handleChange = (event) => {
    let newFormValues = formValues;

    if (event.target.name === 'cemeteryId') {
      fieldChangeCemeteryId(event, newFormValues);
    }
    if (event?.target?.name === 'blockId') {
      const res = fieldChangeBlockId(event, newFormValues);
      if (event.target.value !== '') {
        newFormValues = { ...newFormValues, cemeteryId: res?.cemeteryId };
      }
    }
    setFormValues({ ...newFormValues, [event.target.name]: event.target.value });
  };
  const validateForm = () => {
    let tempErrors = {};
    let formIsValid = true;

    columns.forEach((field) => {
      if (field.required && !formValues[field.name]) {
        tempErrors[field.name] = 'שדה חובה';
        formIsValid = false;
      }
      if (field.notRepeat && formValues[field.name]) {
        if (plots.some((item) => item[field.name] === formValues[field.name])) {
          tempErrors[field.name] = `הערך ${formValues[field.name]} כבר קיים`;
          formIsValid = false;
        }
      }
    });

    setErrors(tempErrors);
    return formIsValid;
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      
      let updatedFormValues = { ...formValues };
      delete updatedFormValues.cemeteryId;

      setLoadingData(true);

      const unicId = uuidv4()

      // שליחה לשרת עם הערך החדש
      let res = await addOrUpdateDataPlot(updatedFormValues, unicId);
      if (res === 200) {
        context?.setContextPlots((prev) => {
          const tempBlock = context?.contextBlocks?.find((b) => b?.unicId === formValues?.blockId);
          updatedFormValues = { ...updatedFormValues, id: unicId, unicId: unicId,
            cemeteryNameHe: tempBlock?.cemeteryNameHe, cemeteryNameEn: tempBlock?.cemeteryNameEn, cemeteryId: tempBlock?.cemeteryId, blockNameHe: tempBlock?.blockNameHe, blockNameEn: tempBlock?.blockNameEn, 
            availableSum: 0, purchasedSum: 0, buriedSum: 0, savedSum: 0, graveSum: 0 };

          // בדיקה אם הערך קיים בסטייט
          const existingIndex = prev.findIndex((item) => item.unicId === updatedFormValues.unicId);

          addRecordToCache(updatedFormValues, 'dataPlots');

          if (existingIndex !== -1) {
            // אם הערך קיים, מעדכן אותו
            const updatedState = [...prev];
            updatedState[existingIndex] = { ...updatedState[existingIndex], ...updatedFormValues };
            return updatedState;
          } else {
            // אם הערך לא קיים, מוסיף אותו
            return [...prev, updatedFormValues];
          }
        });
        setLoadingData(false);
        navigate(-1);
      }
    }
  };

  useEffect(() => {
    async function loadTableData() {
      const localTempData = await getTableData('myDatabase', 'myStore');
      if (localTempData) {
        const dataCemeteries = localTempData.find((item) => item.name === 'dataCemeteries');
        const dataBlocks = localTempData.find((item) => item.name === 'dataBlocks');
        const dataPlots = localTempData.find((item) => item.name === 'dataPlots');
        if (dataCemeteries && dataBlocks && dataPlots) {
          setLoading(false);
        }
      } else {
        // מימוש הקולבק
        const handleDataFetched = (fetchedData) => {
          console.log('Fetched Data:', fetchedData);
          setLoading(false);
          // ניתן לבצע פעולות נוספות כאן עם הנתונים המעודכנים
        };

        // קריאה לפונקציה עם הקולבק
        fetchDataServer(['cemeteries', 'plots'], token, handleDataFetched);
      }
    }
    loadTableData();
  }, []);

  if (loading || loadingData) return <LoadingOverlay />;

  return (
    <>
      <FormTemplate
        title={`הוספת ${NAME_ENTITY}`}
        btn={`שמור`}
        fields={fieldsWithDynamicDisabled}
        columns={columns}
        formValues={formValues}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        errors={errors}
        lockUpdate={value !== undefined}
        options={{
          cemeteryId: cemeteries,
          blockId: blocks
        }}
      />
    </>
  );
}

export default PlotCreate;
